import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import ImageUploadField from './ImageUploadField';

/**
 * Componente para gestionar lista dinámica de elementos (Hipervínculos o Contactos)
 */
const SeccionListaDinamica = ({
    titulo,
    items,
    setItems,
    dialogVisible,
    setDialogVisible,
    itemEdicion,
    setItemEdicion,
    formItem,
    setFormItem,
    agregarItem,
    editarItem,
    guardarItem,
    eliminarItem,
    moverItem
}) => {
    return (
        <div style={{ padding: '1rem' }}>
            <Button
                label={`Agregar ${titulo}`}
                icon="pi pi-plus"
                onClick={agregarItem}
                style={{ marginBottom: '1rem' }}
            />

            <DataTable value={items} emptyMessage={`No hay ${titulo.toLowerCase()}`}>
                <Column field="orden" header="Orden" style={{ width: '80px' }} />
                <Column field="titulo" header="Título" />
                <Column field="contenido" header="Contenido" />
                <Column field="hipervinculo" header="Hipervínculo" />
                <Column
                    header="Imagen"
                    body={(rowData) => (
                        rowData.imagen ? (
                            <i className="pi pi-image" style={{ color: 'green' }}></i>
                        ) : (
                            <i className="pi pi-times" style={{ color: '#ccc' }}></i>
                        )
                    )}
                    style={{ width: '80px', textAlign: 'center' }}
                />
                <Column
                    header="Activo"
                    body={(rowData) => rowData.activo ? '✓' : '✗'}
                    style={{ width: '80px', textAlign: 'center' }}
                />
                <Column
                    header="Acciones"
                    body={(rowData, options) => (
                        <div style={{ display: 'flex', gap: '0.25rem' }}>
                            <Button
                                icon="pi pi-arrow-up"
                                rounded
                                text
                                severity="info"
                                onClick={() => moverItem(options.rowIndex, 'arriba')}
                                disabled={options.rowIndex === 0}
                            />
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                text
                                severity="info"
                                onClick={() => moverItem(options.rowIndex, 'abajo')}
                                disabled={options.rowIndex === items.length - 1}
                            />
                            <Button
                                icon="pi pi-pencil"
                                rounded
                                text
                                severity="warning"
                                onClick={() => editarItem(options.rowIndex)}
                            />
                            <Button
                                icon="pi pi-trash"
                                rounded
                                text
                                severity="danger"
                                onClick={() => eliminarItem(options.rowIndex)}
                            />
                        </div>
                    )}
                    style={{ width: '200px' }}
                />
            </DataTable>

            {/* Dialog para agregar/editar */}
            <Dialog
                visible={dialogVisible}
                style={{ width: '600px' }}
                header={itemEdicion !== null ? `Editar ${titulo}` : `Nuevo ${titulo}`}
                modal
                onHide={() => setDialogVisible(false)}
                footer={
                    <div>
                        <Button
                            label="Cancelar"
                            icon="pi pi-times"
                            onClick={() => setDialogVisible(false)}
                            className="p-button-text"
                        />
                        <Button
                            label="Guardar"
                            icon="pi pi-check"
                            onClick={guardarItem}
                        />
                    </div>
                }
            >
                <div style={{ padding: '1rem' }}>
                    <div className="field" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="orden">Orden</label>
                        <InputNumber
                            id="orden"
                            value={formItem.orden}
                            onValueChange={(e) => setFormItem({ ...formItem, orden: e.value })}
                            style={{ width: '100%', marginTop: '0.5rem' }}
                        />
                    </div>
                    <div className="field" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="titulo">Título</label>
                        <InputText
                            id="titulo"
                            value={formItem.titulo}
                            onChange={(e) => setFormItem({ ...formItem, titulo: e.target.value })}
                            style={{ width: '100%', marginTop: '0.5rem' }}
                        />
                    </div>
                    <div className="field" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="contenido">Contenido</label>
                        <InputTextarea
                            id="contenido"
                            value={formItem.contenido}
                            onChange={(e) => setFormItem({ ...formItem, contenido: e.target.value })}
                            rows={3}
                            style={{ width: '100%', marginTop: '0.5rem' }}
                        />
                    </div>
                    <div className="field" style={{ marginBottom: '1rem' }}>
                        <label htmlFor="hipervinculo">Hipervínculo (URL)</label>
                        <InputText
                            id="hipervinculo"
                            value={formItem.hipervinculo}
                            onChange={(e) => setFormItem({ ...formItem, hipervinculo: e.target.value })}
                            placeholder="https://ejemplo.com"
                            style={{ width: '100%', marginTop: '0.5rem' }}
                        />
                    </div>
                    
                    <ImageUploadField
                        label="Imagen"
                        value={formItem.imagen}
                        onChange={(file) => setFormItem({ ...formItem, imagen: file })}
                        showPreview={true}
                    />

                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '1rem' }}>
                        <Checkbox
                            inputId="activo"
                            checked={formItem.activo}
                            onChange={(e) => setFormItem({ ...formItem, activo: e.checked })}
                        />
                        <label htmlFor="activo">Activo</label>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default SeccionListaDinamica;
